import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { ManualEntryProposalShowData } from '../types/maintenanceManualEntryProposal.type'

interface UseMaintenanceManualEntryProposalProps {
  proposalId: string | undefined;
  options?: Partial<Omit<UseQueryOptions<
    { data: { data: ManualEntryProposalShowData } },
    ErrorResponse,
    ManualEntryProposalShowData
  >, 'queryKey' | 'queryFn'>>;
}

export const useMaintenanceManualEntryProposal = ({
  proposalId,
  options,
}: UseMaintenanceManualEntryProposalProps) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    enabled: !!proposalId,
    queryKey: ['maintenanceManualEntryProposal', proposalId],
    queryFn: () => {
      return privateAxios.get(`/maintenance/establishment_choice/manual_entry_proposals/${proposalId}`);
    },
    select: (response) => response?.data?.data,
    ...options
  });
}
